import React from "react";
import NotificationIcon from "../../Assets/images/notii.svg";
import { formatDistanceToNow } from "date-fns";

function Noticom({ data, onRead }) {
  const { title, message, createdAt, read } = data || {};

  // Convert array [year, month, day, hour, minute, second, nano] to Date
  // month is 1-indexed in the array, but 0-indexed in JS Date
  const dateObj = Array.isArray(createdAt)
    ? new Date(
        createdAt[0],
        createdAt[1] - 1,
        createdAt[2],
        createdAt[3],
        createdAt[4],
        createdAt[5],
      )
    : new Date(createdAt);

  return (
    <div
      onClick={() => !read && onRead()}
      className={`py-4 my-2 px-2 grid-cols-6 grid rounded-md gap-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors ${!read ? "bg-[#CCF2E1]" : ""}`}
    >
      <div className="flex justify-center items-start pt-1">
        <div className="relative">
          <img src={NotificationIcon} alt="Notification" className="w-8 h-8" />
        </div>
      </div>
      <div className="col-span-4">
        <p
          className={`text-[15px] ${!read ? "font-bold text-[#1E222B]" : "font-medium text-[#1E222B]"}`}
        >
          {title}
        </p>
        <p
          className={`text-sm mt-1 line-clamp-2 ${!read ? "text-[#1E222B]" : "text-[#1E222B]"}`}
        >
          {message}
        </p>
      </div>
      <div className="text-right">
        <p
          className={`text-[12px] font-medium ${!read ? "text-[#1E222B]" : "text-[#1E222B]"}`}
        >
          {createdAt ? formatDistanceToNow(dateObj, { addSuffix: true }) : ""}
        </p>
      </div>
    </div>
  );
}

export default Noticom;
